import { Price } from './Price';
import { ProductLabel } from './ProductLabel';
import { TariffLabel } from './TariffLabel';

export const Cells = {
  Price,
  TariffLabel,
  ProductLabel
};
